import { useCallback } from 'react';
import { moldOrderService } from '../services/api';
import { useMoldOrderContext } from '../context/MoldOrderContext';
import { PostMoldOrderRequest } from '../types/moldOrder';

export const useMoldOrders = () => {
  const { state, dispatch } = useMoldOrderContext();

  const fetchMoldOrders = useCallback(
    async (moldId?: number) => {
      try {
        dispatch({ type: 'FETCH_MOLD_ORDERS_START' });
        const response = await moldOrderService.getMoldOrders({ moldId });
        dispatch({ type: 'FETCH_MOLD_ORDERS_SUCCESS', payload: response.data });
      } catch (error) {
        dispatch({
          type: 'FETCH_MOLD_ORDERS_ERROR',
          payload: error instanceof Error ? error.message : 'An error occurred',
        });
      }
    },
    [dispatch],
  );

  const fetchMoldOrdersForKanban = useCallback(
    async (moldId?: number) => {
      try {
        dispatch({ type: 'FETCH_MOLD_ORDERS_START' });
        const response = await moldOrderService.getMoldOrders({
          moldId,
          activeOrders: true,
          includeWorkflowMeta: true,
        });
        dispatch({ type: 'FETCH_MOLD_ORDERS_SUCCESS', payload: response.data });
      } catch (error) {
        dispatch({
          type: 'FETCH_MOLD_ORDERS_ERROR',
          payload: error instanceof Error ? error.message : 'An error occurred',
        });
      }
    },
    [dispatch],
  );

  const createMoldOrder = useCallback(
    async (data: PostMoldOrderRequest) => {
      try {
        dispatch({ type: 'CREATE_MOLD_ORDER_START' });
        const response = await moldOrderService.createMoldOrder(data);
        dispatch({ type: 'CREATE_MOLD_ORDER_SUCCESS', payload: response.data });
        return response.data;
      } catch (error) {
        dispatch({
          type: 'CREATE_MOLD_ORDER_ERROR',
          payload: error instanceof Error ? error.message : 'An error occurred',
        });
        throw error;
      }
    },
    [dispatch],
  );

  // const updateMoldOrder = useCallback(async (id: number, data: Partial<PostMoldOrderRequest>) => {
  //   try {
  //     dispatch({ type: 'UPDATE_MOLD_ORDER_START' });
  //     await moldOrderService.updateMoldOrder(id, data);
  //     dispatch({ type: 'UPDATE_MOLD_ORDER_SUCCESS', payload: { id, updates: data } });
  //   } catch (error) {
  //     dispatch({
  //       type: 'UPDATE_MOLD_ORDER_ERROR',
  //       payload: error instanceof Error ? error.message : 'An error occurred',
  //     });
  //     throw error;
  //   }
  // }, [dispatch]);

  // const deleteMoldOrder = useCallback(async (id: number) => {
  //   try {
  //     dispatch({ type: 'DELETE_MOLD_ORDER_START' });
  //     await moldOrderService.deleteMoldOrder(id);
  //     dispatch({ type: 'DELETE_MOLD_ORDER_SUCCESS', payload: id });
  //   } catch (error) {
  //     dispatch({
  //       type: 'DELETE_MOLD_ORDER_ERROR',
  //       payload: error instanceof Error ? error.message : 'An error occurred',
  //     });
  //     throw error;
  //   }
  // }, [dispatch]);

  // const submitMoldOrderAction = useCallback(async (
  //   id: number,
  //   action: string,
  //   orderDetail?: Record<string, any>
  // ) => {
  //   try {
  //     dispatch({ type: 'SUBMIT_MOLD_ORDER_ACTION_START' });
  //     await moldOrderService.submitAction(id, { action, orderDetail });
  //     dispatch({ type: 'SUBMIT_MOLD_ORDER_ACTION_SUCCESS', payload: { id, action } });
  //   } catch (error) {
  //     dispatch({
  //       type: 'SUBMIT_MOLD_ORDER_ACTION_ERROR',
  //       payload: error instanceof Error ? error.message : 'An error occurred',
  //     });
  //     throw error;
  //   }
  // }, [dispatch]);

  return {
    moldOrders: state.moldOrders,
    loading: state.loading,
    error: state.error,
    fetchMoldOrders,
    createMoldOrder,
    fetchMoldOrdersForKanban,
  };
};
